// extracted by mini-css-extract-plugin
export default {"btns":"BulkPaymentModal_btns__f5p-m","pay_btn":"BulkPaymentModal_pay_btn__Vn+re","nav_item":"BulkPaymentModal_nav_item__mMRPv","unpaid_text":"BulkPaymentModal_unpaid_text__koBaq"};